export default __webpack_public_path__ + "static/follow-pengu-wave-ddb927d7893092d1a270c811672d64ff.gif";